export const addFormFieldStyles = {
	add: {
		pointerEvents: 'auto',
		color: 'text.secondary',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		margin: 'auto',
		padding: 'auto',

		'&:hover': {
			color: 'text.primary',
			backgroundColor: 'transparent'
		}
	},

	icon: {
		width: '15px',
		height: '15px'
	},

	labelled: {
		textTransform: 'uppercase',
		fontWeight: 700,
		gap: 0.5
	}
};
